import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const ManageSchedulerLinkDialogComponentToken = new InjectionToken<ComponentType<any>>(
  'ManageSchedulerLinkDialogComponent',
);
